//@vendor
const isString = require('lodash/lang/isString');

// @ constants
const actionTypes = require('constants/actionTypes');
const { DATE_FORMAT_API } = require('constants/index');

// @ commons
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder.js');

const setAmount = (amount) => ({
    type: actionTypes.CREATE_CHORE_SET_AMOUNT,
    payload: {
        amount
    }
});

const setChoreType = (choreType) => ({
    type: actionTypes.CREATE_CHORE_SET_CHORE_TYPE,
    payload: {
        choreType
    }
});

const validityDateChanged = (selectedEndDate) => ({
    type: actionTypes.CREATE_CHORE_VALIDITY_DATE_CHANGED,
    payload: {
        selectedEndDate
    }
});

const conceptChanged = (concept) => ({
    type: actionTypes.CREATE_CHORE_CONCEPT_CHANGED,
    payload: {
        concept
    }
});

const setVisibleStep = (step)  => ({
    type: actionTypes.CREATE_CHORE_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const validateStep = (step) => ({
    type: actionTypes.CREATE_CHORE_VALIDATE_STEP,
    payload: {
        step
    }
});

const reset = () => ({
    type: actionTypes.CREATE_CHORE_RESET
});

const setWillCancel = (willCancel) => ({
    type: actionTypes.CREATE_CHORE_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const requestOpenYoungChoreListDetails = () => ({
    type: actionTypes.CREATE_CHORE_DETAILS_REQUEST
});

const requestOpenYoungChoreListSuccess = (choreList) => ({
    type: actionTypes.CREATE_CHORE_DETAILS_SUCCESS,
    payload: {
        choreList
    }
});

const requestOpenYoungChoreListFailure = (getChoreDetailsError) => ({
    type: actionTypes.CREATE_CHORE_DETAILS_ERROR,
    payload: {
        getChoreDetailsError
    }
});

const requestOpenYoungCreateChore = () => ({
    type: actionTypes.CREATE_CHORE_CONFIRM_REQUEST
});

const requestOpenYoungCreateChoreSuccess = (cardDetails) => ({
    type: actionTypes.CREATE_CHORE_CONFIRM_SUCCESS,
    payload: {
        cardDetails
    }
});

const requestOpenYoungCreateChoreFailure = (error) => ({
    type: actionTypes.CREATE_CHORE_CONFIRM_ERROR,
    payload: {
        error
    }
});

const setTotalAvailableBalance = (totalAvailableBalance) => ({
    type: actionTypes.CREATE_CHORE_AVAILABLE_BALANCE,
    payload: {
        totalAvailableBalance
    }
});

const setRepetitionType = (selectedRepetitionType) => ({
    type: actionTypes.CREATE_CHORE_SET_REPETITION_TYPE,
    payload: {
        selectedRepetitionType
    }
});
const setRepetitionOptionsList = (repetitionOptionList) => ({
    type: actionTypes.CREATE_CHORE_SET_REPETITION_OPTION_LIST,
    payload: {
        repetitionOptionList
    }
});

const getChoresList = () => (dispatch) => {
    dispatch(requestOpenYoungChoreListDetails());
    return APIGet({
        dispatch,
        endpoint: 'openYoungChoreTypesList',
        url: apiURLBuilder.getURL('openYoungChoreTypesList')
    })
    .then(response => dispatch(requestOpenYoungChoreListSuccess(response)))
    .catch( response => {
        if (!!response.error) {
            dispatch(requestOpenYoungChoreListFailure(response.error))
        } else {
            throw response;
        }
    })
}

const postChoreConfirm = (immCard, step) => (dispatch) => {
    const repetitionType = step.getIn(['selectedRepetitionType','value']);
    const repeatTask = isString(repetitionType) ? 0 : repetitionType;
    const panNumber = immCard.getIn(['interventionList',0,'pan']);
    const requestData = {
    query: {
            assignmentRequest: [
                {
                    childDetail: {
                        contractNumber: immCard.getIn(['contract','number']), 
                        pan: panNumber && panNumber.substr(-4),
                        productCode: immCard.getIn(['contract','product'])
                    },
                    choreAssignmentComment: step.get('concept'),
                    choreId: step.getIn(['choreType',0,'choreId']),
                    endDate: step.get('selectedEndDate').format(DATE_FORMAT_API),
                    repeatTask: repeatTask, 
                    reward: step.get('amount')
                }
            ]
        }
    }

    dispatch(requestOpenYoungCreateChore());
    return APIPost({
        dispatch,
        endpoint: 'openYoungCreateChoreConfirm',
        url: apiURLBuilder.getURL('openYoungCreateChoreConfirm'),
        params: requestData
    })
    .then(response => dispatch(requestOpenYoungCreateChoreSuccess(response)))
    .catch( response => {
        if (!!response.error) {
            dispatch(requestOpenYoungCreateChoreFailure(response.error))
        } else {
            throw response;
        }
    })
}

module.exports = {
    conceptChanged,
    getChoresList,
    postChoreConfirm,
    reset,
    setAmount,
    setChoreType,
    setTotalAvailableBalance,
    setVisibleStep,
    setWillCancel,
    setRepetitionType,
    setRepetitionOptionsList,
    validateStep,
    validityDateChanged
}
